module.exports = __webpack_public_path__ + "static/media/Confer-logo.dace2897.png";